import moment from 'moment'
import { split } from "lodash";

const useUtils = () => {
	const formatAmount = (amount, digits = 2) => {
		const formattedAmount = Number(amount).toLocaleString('de-ch', { minimumFractionDigits: digits, maximumFractionDigits: digits });
		return formattedAmount;
	};

	const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

	const getLabelArray = (component, arrayName, keyName = 'label', valueName = 'value') => {
		let textsArr = [];
		let index = 0;
		while (index != -1) {
			const keyLabel = arrayName + '.' + index + '.' + keyName;
			const label = component.$t(keyLabel);
			if (label != keyLabel) {
				textsArr.push({ label: label, value: component.$t(arrayName + '.' + index + '.' + valueName) });
				index++;
			} else {
				index = -1;
			}
		}
		return textsArr;
	};

	/**
	 * Searches in the array of objects of type: {name: ..., id:...} for a particular name and returns corresponding id
	 * @param list array of objects of type: {name: ..., id:...}
	 * @param name name
	 * @return int | corresponding id or 0 if not found
	 */
	const findElementId = (list, name) => {
		let el = list.find((curItem) => {
			if (curItem.name == name) return true;
		});
		return el ? el.id : 0;
	};

	/**
	 * Copies the passed in object
	 * @param dataObj object to be copied
	 * @return mix | a copy of the passed in object
	 */

	const doCopy = (dataObj) => {
		return JSON.parse(JSON.stringify(dataObj));
	};
/**
 * Checks if object is empty
 * @param {*} obj
 * @returns bool
 */
	const isEmptyObj = (obj) => {
		return Object.keys(obj).length === 0
	}

	/**
	 * opens download dialog in browser with the contents of the blob
	 *
	 * @param {*} blob file data
	 * @param string filename
	 */
	const sendToBrowser = (blob, filename) => {
		const imageURL=window.URL.createObjectURL(blob);
		const anchor=document.createElement("a");
		anchor.href=imageURL;
		anchor.download=filename;
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
		window.URL.revokeObjectURL(imageURL);
	}

	/**
	 * Returns the largest number less than or equal to a given number considering the passed in accuracy
	 *
	 * @param int|float number original number
	 * @param int|float accuracy accuracy e.g. 1000 or 0.05
	 * @return the largest number less than or equal to a given number considering the passed in accuracy
	 */
	const floor = (number, accuracy)=> {
		return Math.floor(number / accuracy) * accuracy;
	}

	/**
	 * Returns rounds a number to the nearest considering the passed in accuracy
	 *
	 * @param int|float number original number
	 * @param int|float accuracy accuracy e.g. 1000 or 0.05
	 * @return the largest number less than or equal to a given number considering the passed in accuracy
	 */
	const round = (number, accuracy)=> {
		return Math.round(number / accuracy) * accuracy;
	}

	const getCurUserId = () => {
		return localStorage.getItem('curUserId')
	}

	const setCurUserId = (userId) => {
		localStorage.setItem('curUserId', userId)
	}

	//returns the user local from backend if defined, or:
	//reads user defined locale from localStorage or if not defined returns language of the browser or default_locale
	//if the selected locale is not in the list of available locales, the default locale is returned
	const getUserLocale = (locale, availableLocales) => {
		let lang = ''
		if (locale.user) {
			lang = locale.user
		} else {
			lang = localStorage.getItem('lang') || navigator.language || navigator.userLanguage || locale.default;
			lang = lang?.split('-')[0]
			lang = findInArrayOfObjects(availableLocales, 'value', lang) ? lang : locale.default;
		}
		return lang;
	}

	const findInArrayOfObjects = (arrayOfObjects, element, value) => {
		return arrayOfObjects.find(obj => obj[element] === value);
	}

	const updateUserLocale = (locale, i18n) => {
		const browserLocale=localStorage.getItem('lang')
		if (locale && locale!==browserLocale) {
			localStorage.setItem('lang', locale)
			if (i18n) {
				i18n.locale=locale;
			}
		}
	}

	/**
	 * Sorts lists in alphabetical order.
	 * @param unsortedList list to be sorted
	 * @param keyName the name of the key in the list
	 * @param sortingValueName the name of the key/value in the list that shall be sorted alphabetical
	 * @param lastKeyValue [optional] a key (corresponds to the keyName) value that should be placed as last in the list
	 * @param priorityKeyList [optional] array containing a list of keys, which should be placed at the very beginning of the sorted list.
	 * @returns {*} passed in list sorted in alphabetical order
	 */
	const sortList = (unsortedList, keyName, sortingValueName, lastKeyValue = null, priorityKeyList = []) => {
		return unsortedList.sort((a, b) => {
			let result = 0; // Default to 0 (no sorting preference)
			const keyA = a[keyName];
			const keyB = b[keyName];
			if (lastKeyValue) {
				// Ensure the lastKeyValue is always sorted as if it's the largest value.
				if (keyA === lastKeyValue) {
					result = 1;
				} else if (keyB === lastKeyValue) {
					result = -1;
				}
			} else if (priorityKeyList.length > 0) {
				const indexA = priorityKeyList.indexOf(keyA);
				const indexB = priorityKeyList.indexOf(keyB);
				if (indexA !== -1 && indexB !== -1) {
					result = indexA - indexB; // Both are in priority list, sort by index
				} else if (indexA !== -1) {
					result = -1; // Only a is in priority, it comes first
				} else if (indexB !== -1) {
					result = 1; // Only b is in priority, it comes first
				}
			}
			if (!result) {
				// Ensure both a.text and b.text are valid strings
				const textA = a[sortingValueName] || '';
				const textB = b[sortingValueName] || '';
				result = textA.localeCompare(textB); // Alphabetical sorting
			}
			return result;
		});
	}

	const timezoneOffset = moment().utcOffset()

	const timeZoneOffsetOnInit = (date, format) => {
		/*
		let formattedDate = null;
		if (date) {
			let momentDate = moment(date);
			if (false) {
				momentDate = moment.utc(date).local() // Convert from UTC to local
			}
			formattedDate = momentDate.format(format);
		}
		return formattedDate;
		*/
		/*
		if (!date) return null
		const m = moment.utc(date).local() // Convert from UTC to local
		return format ? m.format(format) : m.format()
		*/
		if (date) {
			date = moment(date)
			if (timezoneOffset < 0) {
				date = date.subtract(timezoneOffset, 'minutes')
			}
			date = format !== '' ? date.format(format) : date.format()
		}
		return date
	}

	const timeZoneOffsetOnSave = (date) => {
		/*let formattedDate = null;
		if (date) {
			let momentDate = moment(date);
			const time = momentDate.format('HH:mm:ss');
			if (time !== '00:00:00') {
				momentDate = momentDate.utc();
			}
			formattedDate = momentDate.format(); // Convert from local to UTC ISO
		}
		return formattedDate;
		*/
		if (date) {
			date = moment(date)
			const time = date.format('HH:mm:ss');
			if (timezoneOffset > 0 && time !== '00:00:00') {
				date = date.subtract(timezoneOffset, 'minutes')
			}
			date = date.format()
		}
		return date
	}

	/**
	 * Compares two dates.
	 * @param date1
	 * @param date2
	 * @param format
	 * @returns {number} 0 - either dates are equal or one of the dates is not valid; 1 - date1 is after date2; -1 - date1 is before date2
	 */
	const compareDates = (date1, date2, format) => {
		const d1 = moment(date1, format, true);
		const d2 = moment(date2, format, true);
		let result = 0;
		if (!d1.isValid() || !d2.isValid()) {
			result = 0;
		} else if (d1.isBefore(d2)) {
			result = -1;
		} else if (d1.isAfter(d2)) {
			result = 1;
		}
		return result;
	}

	/**
	 * Returns whether the passed in date is before
	 * @param date
	 * @param amount
	 * @param unit
	 * @returns {boolean} Returns true if date + amount * unit is after the current time,
	 * meaning the original date is before that future point. Otherwise, it returns false.
	 */
	const isDateBefore = (date, amount, unit) => {
		return date ? moment(date).add(amount, unit).isAfter(moment()) : false;
		//this.moment().subtract(amount, unit).isBefore(this.moment(date))
	}

	const isFormattedDateValid = (date, format) => {
		return moment(date, format, true).isValid();
	}

	/**
	 * Returns an ISO 8601 string of the given date with the local time and timezone offset preserved.
	 * @param date
	 */
	const localTimeWithOffset = (date) => {
		return moment(date).toISOString(true);
	}

	/**
	 * Format the passed in date.
	 * @param date
	 * @param format
	 * @returns {string}
	 */
	const formatDate = (date, format) => {
		let formattedDate = date;
		if (date == 'Invalid date') {
			formattedDate = '';
		} else if (date) {
			formattedDate = moment(date).format(format);
		}
		return formattedDate;
	}

	return {
		formatAmount,
		sleep,
		getLabelArray,
		findElementId,
		doCopy,
		sendToBrowser,
		floor,
		round,
		getCurUserId,
		setCurUserId,
		isEmptyObj,
		getUserLocale,
		updateUserLocale,
		findInArrayOfObjects,
		sortList,
		timeZoneOffsetOnInit,
		timeZoneOffsetOnSave,
		compareDates,
		isDateBefore,
		isFormattedDateValid,
		localTimeWithOffset,
		formatDate
	};
};

export default useUtils;
